import { useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import { BACKEND_URL } from "../../../../services/Api";

const AddWorkTypeModal = ({ open, onClose, onSave, editData }) => {
    const [name, setName] = useState("");
    const [image, setImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const fileInputRef = useRef(null);


    useEffect(() => {
        if (open) {
            setName(editData?.workTypeName || "");
            setImage(null)
            setPreviewUrl(null);
        }
    }, [open, editData]);

    if (!open) return null;

    const submit = () => {
        const fd = new FormData();
        fd.append("workTypeName", name);
        if (image) fd.append("image", image);
        onSave(fd);
    }

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">
                <div className="admin-modal-header">
                    <div className="admin-modal-title">
                        {editData ? "Edit Work Type" : "Add Work Type"}
                    </div>
                    <button onClick={onClose}>
                        <IoClose />
                    </button>
                </div>

                <div className="admin-form-body">
                    <label className="admin-label">Work Type Name</label>
                    <input value={name} onChange={(e) => setName(e.target.value)} className="admin-input" />
                </div>
                {editData?.workImageUrl && (
                    <div className="admin-form-body">
                        <label className="admin-label">Current Image</label>

                        <img
                            src={`${BACKEND_URL}${editData.workImageUrl}`}
                            alt="Existing Work Type"
                            style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "contain",
                                border: "1px solid #d1d5db",
                                borderRadius: "6px",
                            }}
                        />

                        <div style={{ fontSize: "12px", color: "#374151", marginTop: "4px" }}>
                            Existing: {editData.workImageUrl.split("/").pop()}
                        </div>
                    </div>
                )}

                {previewUrl && (
                    <div className="admin-form-body">
                        <label className="admin-label">New Image (Preview)</label>

                        <div style={{ position: "relative", display: "inline-block" }}>
                            <img
                                src={previewUrl}
                                alt="New Preview"
                                style={{
                                    width: "80px",
                                    height: "80px",
                                    objectFit: "contain",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "6px",
                                }}
                            />

                            {/* REMOVE ICON */}
                            <span
                                onClick={() => {
                                    setImage(null);
                                    setPreviewUrl(null);
                                    if (fileInputRef.current) {
                                        fileInputRef.current.value = "";
                                    }
                                }}
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-6px",
                                    background: "#ef4444",
                                    color: "#fff",
                                    borderRadius: "50%",
                                    width: "18px",
                                    height: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                }}
                                title="Remove selected image"
                            >
                                ×
                            </span>
                        </div>

                        <div style={{ fontSize: "12px", color: "#374151", marginTop: "4px" }}>
                            Selected: {image?.name}
                        </div>
                    </div>
                )}

                {/* FILE INPUT */}
                <div className="admin-form-body">
                    <label className="admin-label">
                        {editData ? "Change Image" : "Work Image"}
                    </label>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                                setImage(file);
                                setPreviewUrl(URL.createObjectURL(file));
                            }
                        }}
                        className="admin-input"
                    />
                </div>

                <div className="admin-form-footer">
                    <button onClick={onClose} className="admin-btn-cancel">CANCEL</button>
                    <button onClick={submit} disabled={!name.trim()} className="admin-btn-save">SAVE</button>
                </div>
            </div>
        </div>
    )
}

export default AddWorkTypeModal;